import { ILangState } from "./interface";

export default <ILangState> {
	lang: 'ru'
}